const ve = {
    CustomEvent: "ce",
    Pr: "p",
    du: "pc",
    dc: "ca",
    ka: "i",
    Is: "ie",
    P: "cci",
    T: "ccic",
    $: "ccc",
    H: "ccd",
    Wl: "ss",
    xl: "se",
    _i: "si",
    Ii: "sc",
    Mi: "sbc",
    Ze: "sfe",
    ro: "iec",
    au: "lr",
    Zh: "uae",
    R: "ci",
    B: "cc",
    gu: "lcaa",
    fu: "lcar",
    Rn: "inc",
    Bn: "add",
    Ln: "rem",
    Fn: "set",
    $n: "ncam",
    pu: "sgu"
  },
  De = { Ar: "feed_displayed", Cc: "content_cards_displayed" };
export { ve as EventTypes, De as InternalEventTypes };
